export const widthProps = ['width']
export const maxWidthProps = ['maxWidth']
export const minWidthProps = ['minWidth']
export const heightProps = ['height']
export const maxHeightProps = ['maxHeight']
export const minHeightProps = ['minHeight']
export const displayProps = ['display']
export const verticalAlignProps = ['verticalAlign']
export const sizeProps = ['size']
export const overflowProps = ['overflow', 'overflowX', 'overflowY']

export const alignItemsProps = ['alignItems']
export const alignContentProps = ['alignContent']
export const justifyItemsProps = ['justifyItems']
export const justifyContentProps = ['justifyContent']
export const flexWrapProps = ['flexWrap']
export const flexBasis = ['flexBasis']
export const flexDirection = ['flexDirection']
export const flexProps = ['flex']
export const justifySelfProps = ['justifySelf']
export const alignSelfProps = ['alignSelf']
export const orderProps = ['order']
export const flexGrowProps = ['flexGrow']
export const flexShrinkProps = ['flexShrink']

export const layoutProps = [
  ...widthProps,
  ...maxWidthProps,
  ...minWidthProps,
  ...heightProps,
  ...maxHeightProps,
  ...minHeightProps,
  ...displayProps,
  ...verticalAlignProps,
  ...sizeProps,
  ...overflowProps,
]

export const flexboxProps = [
  ...alignItemsProps,
  ...alignContentProps,
  ...justifyItemsProps,
  ...justifyContentProps,
  ...flexWrapProps,
  ...flexBasis,
  ...flexDirection,
  ...flexProps,
  ...justifySelfProps,
  ...alignSelfProps,
  ...orderProps,
  ...flexGrowProps,
  ...flexShrinkProps,
]

export const spaceProps = [
  'm',
  'margin',
  'mt',
  'marginTop',
  'mr',
  'marginRight',
  'mb',
  'marginBottom',
  'ml',
  'marginLeft',
  'mx',
  'marginX',
  'my',
  'marginY',
  'p',
  'padding',
  'pt',
  'paddingTop',
  'pr',
  'paddingRight',
  'pb',
  'paddingBottom',
  'pl',
  'paddingLeft',
  'px',
  'paddingX',
  'py',
  'paddingY',
]

export const borderRadiusProps = [
  'borderRadius',
  'borderTopLeftRadius',
  'borderTopRightRadius',
  'borderBottomLeftRadius',
  'borderBottomRightRadius',
]
